var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"smartTown"}},[_c('div',{staticClass:"title"},[_vm._v("国务院办公厅关于印发“十四五”国民健康规划的通知")]),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v("为全面推进健康中国建设，根据《中华人民共和国国民经济和社会发展第十四个五年规划和2035年远景目标纲要》、《“健康中国2030”规划纲要》，编制本规划。")]),_vm._v(" "),_c('div',{staticClass:"btn",on:{"click":function($event){return _vm.toLink()}}},[_vm._v("查看详情")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c791870c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/news1.vue
// module id = null
// module chunks = 